export type WorkstationSettingsData = {
  isMapWorkstationToRoomEnabled: boolean;
  roomId: number | null;
  isOnlineMeasurementsDisabled: boolean;
};

export const defaultWorkstationSettings: WorkstationSettingsData = {
  isMapWorkstationToRoomEnabled: false,
  roomId: null,
  isOnlineMeasurementsDisabled: false,
};

export enum WorkstationSettingsKeys {
  'WorkstationSettings' = 'workstationSettings',
}
